const ACTION_TYPES = {
    RESET_EDIT_INLINE_STATE: 'RESET_EDIT_INLINE_STATE',
    SET_EDIT_FOLDER: 'SET_EDIT_FOLDER',
    SET_EDIT_INLINE: 'SET_EDIT_INLINE',
};

function resetEditInlineState() {
    return { type: ACTION_TYPES.RESET_EDIT_INLINE_STATE };
}

function setEditFolder({ editFolder }) {
    return { type: ACTION_TYPES.SET_EDIT_FOLDER, editFolder };
}

function setEditInline({ editInline }) {
    return { type: ACTION_TYPES.SET_EDIT_INLINE, editInline };
}

export default {
    ...ACTION_TYPES,
    resetEditInlineState,
    setEditFolder,
    setEditInline,
};
